import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";
import DropdownValues from "../../Student/Reusablecomponents/DropDownValues";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler
);
const StateTrends = (props) => {
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const USYear = useSelector((state) => state.SelecYearData.SYear);
  const [SPTrends, SetSPTrends] = useState();
  const [SelectSTate, SetSelectState] = useState(props.StateIds?.[0].value);

  const StatePerformanceTrends = async (Stateid) => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/InstitutionAdmin/GetStatePerformanceTrendsByInstitute?Year=${USYear?.value}&AssessmentType=${props.AType}&InstituteId=${items?.instituteId}&StateId=${Stateid}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].assessmentDate) {
          SetSPTrends(res.data);
          const subjects = [
            ...new Set(res.data.map((item) => item.subjectName)),
          ];
          props.StoreSubjects(subjects);
          props.StoreSelSub(subjects[0]);
        } else {
          SetSPTrends(process.env.REACT_APP_NODATAFOUND_Participated);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (props.SelectedState?.StateID || SelectSTate)
      StatePerformanceTrends(props.SelectedState?.StateID || SelectSTate);
  }, [SelectSTate, props.AType, props.SelectedState?.StateID, USYear]);
  const labels = [];
  const Subjects = {};

  if (SPTrends?.[0].assessmentDate) {
    SPTrends?.forEach((item) => {
      if (
        !labels.includes(item.assessmentDate) &&
        props.SubSelect === item.subjectName
      ) {
        labels.push(item.assessmentDate);
      }
      if (!Subjects[item.subjectName]) {
        Subjects[item.subjectName] = [];
      }
    });
    SPTrends?.forEach((item) => {
      Subjects[item.subjectName].push(item.percentage);
    });
  }

  const datasets = Object.keys(Subjects).map((Subject) => ({
    label: Subject,
    data: Subjects[props.SubSelect],
    backgroundColor:
      {
        English: "#7C60BC",
        Mathematics: "#00A2B9",
        Science: "#3DA663",
        Biology: "#F7C66A",
        BioTechnology: "#A63D95",
        "Physics and Chemistry": "#3B9ED7",
      }[(Subject, props.SubSelect)] || "#000",
    borderColor:
      {
        English: "#7C60BC",
        Mathematics: "#00A2B9",
        Science: "#3DA663",
        Biology: "#F7C66A",
        BioTechnology: "#A63D95",
        "Physics and Chemistry": "#3B9ED7",
      }[(Subject, props.SubSelect)] || "#000",

    maxBarThickness: 40,
    barThickness: 45,
  }));

  // datasets.push({
  //   label: 'Regional',
  //   data: RPTrends, // Static data here
  //   backgroundColor: '#FF6384', // Set your desired color
  //   borderColor: '#FF6384',
  //   fill: false,
  //   maxBarThickness: 40,
  //   barThickness: 45,
  // });
  const data = { labels: labels, datasets: datasets };
  const options = {
    aspectRatio: 2,
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: function (context) {
            if (context.dataset.label === props.SubSelect) {
              const label = context.dataset.label || "";
              const value =
                context.parsed.y !== null ? context.parsed.y + "%" : "";
              return `${label}: ${value}`;
            }
            return null;
          },
        },
      },
    },
    scales: {
      x: {
        offset: 20,
        grid: { display: false },
        title: { display: true, text: "Assessment Date" },
      },
      y: {
        title: { display: true, text: "Performance %" },
        beginAtZero: true,
        max: 100,
      },
    },
  };

  return (
    <>
      <div className="dflex JSBetween mb-2">
        <div className="SubHeading">
          Statewise performance{" "}
          {props.SelectedState?.StateName &&
            `- ${props.SelectedState?.StateName}`}
        </div>
        {!props.SelectedState && (
          <div>
            {" "}
            {props.StateIds && (
              <DropdownValues
                className="NCLDropdown"
                options={props.StateIds}
                onChange={(e) => SetSelectState(e.target.value)}
                selectoption={SelectSTate}
              />
            )}
          </div>
        )}
      </div>

      {SPTrends?.[0].assessmentDate ? (
        labels.length !== 0 ? (
          <Line options={options} data={data} />
        ) : (
          <div className="ErrorMessage">
            {process.env.REACT_APP_NODATAFOUND_Participated}
          </div>
        )
      ) : (
        <div className="ErrorMessage">{SPTrends}</div>
      )}
    </>
  );
};
export default StateTrends;
